"use client";

import { useSelectedLayoutSegments } from "next/navigation";
import { type ReactNode } from "react";

import { cn } from "@trip/utils";

import { Link } from "~/navigation";

export function NavLink({
  href,
  children,
  segment,
}: {
  children: ReactNode;
  href: string;
  segment: string | null;
}) {
  const [currentSegment] = useSelectedLayoutSegments();
  const isCurrentSegment =
    segment === (currentSegment ?? null) ||
    (currentSegment === "search" && segment === "tours");
  return (
    <Link
      href={href}
      className={cn(
        "whitespace-nowrap p-2 md:px-3",
        isCurrentSegment ? "text-neutral-900" : "text-neutral-500",
        segment === "orders" ? "text-prune-500" : "",
      )}
    >
      {children}
    </Link>
  );
}
